export function dashFormatPhoneNumber(phone: string): string {
    phone = (phone || '').replace(/\D/g, '');
    let result = "";
    for (let i = 0; i < phone.length; i++) {
        if (i === 0) {
            result = phone[i] + "-";
        }
        else if (i === 3) {
            result = result + phone[i] + "-";
        }
        else if (i === 6) {
            result = result + phone[i] + "-";
        }
        else {
            result = result + phone[i];
        }
    }
    return result;
}
